export default "__VITE_ASSET__BWIM_QfZ__"